export default "__VITE_ASSET__CaOZVzL2__"